import { h, render } from 'preact';
import { App } from './app';
import { FooterTemplate } from './types';

export const initGF = (
  footerTemplate: FooterTemplate,
  container: HTMLElement
) => {
  const parent = container.parentNode;

  if (!parent) {
    console.error('cbgGlobalFooter:: container has no parent node');
    return;
  }

  if (container.dataset.cbgGfInitialized === 'true') {
    return;
  }

  // Keep the original placeholder in the DOM as a hidden sentinel so host apps
  // retain ownership of the container and can safely re-render without breaking.
  container.style.display = 'none';
  container.dataset.cbgGfInitialized = 'true';

  const mountNode = document.createElement('div');
  render(h(App, { footerTemplate }), mountNode);

  // Insert the actual rendered footer items as siblings immediately before the
  // hidden marker so the host element remains in the DOM and the template can
  // legitimately render list-like structures (e.g. li > a).
  while (mountNode.firstChild) {
    parent.insertBefore(mountNode.firstChild, container);
  }

  if (parent instanceof Element) {
    parent.setAttribute('data-cbg-gf-initialized', 'true');
  }
};
